const getVenueScopedValue = (venueId, byVenueId, venuesHighLevelById) => {
  const owningVenueId = venuesHighLevelById?.[venueId]?.parent_venue_id || venueId

  return byVenueId?.[venueId] || byVenueId?.[owningVenueId]
}

export const getPermissionsForVenue = (venueId, permissionsByVenueIdByType, venuesHighLevelById) => getVenueScopedValue(venueId, permissionsByVenueIdByType, venuesHighLevelById) || {}

export const getRolesForVenue = (venueId, rolesByVenueId, venuesHighLevelById) => getVenueScopedValue(venueId, rolesByVenueId, venuesHighLevelById) || []
